import { service } from '@/utils/net'

// 1:钻石流水 2:金豆流水 3:公会周榜, 默认是1
type TActivityType = 1 | 2 | 3 | 4 | 5
const activityType: TActivityType = 5

// 奖池
export async function getRewardsPool(): Promise<
  Response<RoomRewards.RewardsPool>
> {
  return service({
    method: 'GET',
    params: {
      activityType
    },
    url: '/doniaLiveH5doings/room/activity/getRewardsPool'
  }).then((res) => res?.data)
}

// 获取奖励配置
export async function getReWardsList(): Promise<
  Response<RoomRewards.RewardItem[]>
> {
  return service({
    method: 'GET',
    params: {
      activityType
    },
    url: '/doniaLiveH5doings/room/activity/getRewards'
  }).then((res) => res?.data)
}

// 榜单
export async function getRank(rankType?: 0 | 1): Promise<Response<RoomRewards.RankResponse>> {
  return service({
    method: 'GET',
    params: {
      activityType,
      rankType
    },
    url: '/doniaLiveH5doings/room/activity/getRank'
  }).then((res) => res?.data)
}
